import { AxiosError } from 'axios'
import { useCallback } from 'react'
import { useQuery } from 'react-query'
import { OAuthInteractionResponse } from '../interfaces/OAuthInteractionResponse'
import { OAuthErrorResponse } from '../interfaces/OAuthErrorResponse'
import { useIamManagerOAuth } from '../useIamManagerOAuth'

export const oauthInteractionQueryKey = (id: string) => ['oauth', 'interaction', id]

export const useGetOAuthInteraction = (id: string) => {
  const { getInteraction } = useIamManagerOAuth()
  const queryFn = useCallback(async () => (await getInteraction(id)).data, [getInteraction, id])
  return useQuery<OAuthInteractionResponse, AxiosError<OAuthErrorResponse>>({
    queryKey: oauthInteractionQueryKey(id),
    queryFn,
    cacheTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })
}
